import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import img1 from "../assets/img/bandeau.jpg";
import mathis1 from "../assets/bebe/mathis.jpg";
import mathis2 from "../assets/bebe/mathis2.jpg";

export const Mathis = () => {
  return (
    <>

      <div className="banner-titre-container">
        <img src={img1} className="back-img" />
        <div className='over-banner'>
          <div className='info-banner'>
            <h1 className='banner-title'> Bienvenue sur Terre petit ange ...</h1>
          </div>
        </div>
      </div>

      <div className='block-container bottom-space side-space-margin top-space-margin'>
        <Row>
          <Col xs={12} lg={9}>

            <div className='central-block central-block-margin'>
              <div id="left">
                <strong style={{
                  textAlign: 'center',
                  fontFamily: 'Raleway, sans-serif',
                  fontWeight: 600,
                  fontSize: '30px'
                }}>Accueil des Nouveau-Nés : Bébé-Channeling		</strong>
                <h2 align="right"><span class="style4"><img src={mathis2} alt="" width="73" height="83" /></span></h2>
                <p class="style7"><strong>Ame de Mathis,  à 11 mois :</strong>
                </p><br />
                <p align="justify" class="style7"><strong>"Familles Universelles, je vous aime.</strong> J'ai poliment attendu qu'on vienne me chercher, car il ne faut jamais brusquer les choses. Il faut prendre son temps si on ne veut pas être brusqué soi-même. Je vais au rythme qui est le mien, exactement comme je le souhaite. J'ai besoin de ressentir l'harmonie autour de moi ... qu'on me laisse avancer à mon pas. Ma curiosité me tient en éveil.</p><br />
                <p align="justify" class="style7">J'avais peur de perdre mes mémoires à ma naissance. Elles s'effacent, je dirais, elles sont remplacées petit à petit par le goût du présent ... pourquoi vouloir à tout prix se souvenir d'un goût sucré passé, alors que le présent est si savoureux ?</p><br />
                <p align="justify" class="style7"><strong>J'ai plaisir à laisser ma force passer par mes yeux</strong> .. plaisir à redécouvrir le ré-apprentissage des mécanismes anciens ... bouger, manger, marcher, chanter, parler ... je suis content des présents quotidiens que m'offre chaque nouveau réveil.</p><br />
                <p align="justify" class="style7">Je suis si bien entouré. Je ne manque de rien et quand j'ai besoin de quelque chose, je vais le chercher pendant mon sommeil. Mon âme me sert bien. Nous allons bien tous les deux et nous sommes heureux de contribuer à nous faire connaître, nous les bébés de l'an 2008 ...</p><br />
                <p align="justify" class="style7">Nous sommes si nombreux à émerger de nos coquilles, si pleins de vie, nous sommes sur votre chemin ... si nombreux ... ensemble avec vous ... pour vous ... ensemble ..."</p>
                <p align="justify" class="style10">&nbsp;</p>
              </div>

            </div>
          </Col>
          <Col xs={12} lg={3}>
            <div className='right-block right-block-margin'>
              <div id="right">

                <p align="center"><img src={mathis1} alt="" width="118" height="116" /></p>
                <p align="left" class="style11"><strong>Mathis :</strong></p>
                <p align="left" class="style12"><i>"Familles Universelles, je vous aime ..."</i></p>
                <p align="left" class="style4">&nbsp;</p>
                <p align="left" class="style11"><strong>Père de Mathis :</strong></p>
                <i><p align="left" class="style12">"C'est bien de savoir ce que ressent et ce qui anime mon fils ... </p>
                  <p align="left" class="style12">... Nous communiquons par le regard, et  je le rassure."</p></i>
                <div className='bouton-rectangle-container'>
                  <Link to={'/contact'} className='bouton-rectangle-music'>
                    Me contacter
                  </Link>
                </div>
              </div>

            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}

